import { Injectable } from '@angular/core';
import { LocalParemeters } from './4.4.local/local.parameters';
import { ContractRepositoryParameters } from './4.2.contract/contract.parameters/contract.repository.parameters';

@Injectable({
    providedIn: 'root'
})
export class RespositoryParameters implements ContractRepositoryParameters{

    constructor(
        private localParameters: LocalParemeters
    ){}

    getCryptoKey(): string {
        return this.localParameters.getCryptoKey();
    }

}